import React, { Suspense, Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import Templates from './pages/templates'
import License from './pages/license'
import Privacy from './pages/privacy'
import Themes from './pages/themes'
import Terms from './pages/terms'

import Loader from './utils/loader.component'
import UserSettings from './auth/userSettings.container'
import Forgot from './auth/forgot.component'
import { Signup, Login, getUser as getUserActionCreator } from './auth'

const Builder = React.lazy(() => import('./builder/builder.container'))
const Projects = React.lazy(() => import('./project/myProjects.container'))

class WithUserRoutes extends Component {
  componentDidMount() {
    const { getUser } = this.props
    getUser()
  }

  render() {
    return (
      <Switch>
        <Suspense fallback={<Loader />}>
          <Route path="/app" render={props => <Builder {...props} />} exact />
          <Route path="/app/project/:projectId" render={props => <Builder {...props} />} />
          <Route path="/signup" component={Login} exact />
          <Route path="/login" component={Login} exact />
          <Route path="/forgot/:code?" component={Forgot} exact />
          <Route path="/app/projects" render={props => <Projects {...props} />} exact />

          <Route path="/terms" component={Terms} />
          <Route path="/themes" component={Themes} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/license" component={License} />
          <Route path="/templates" component={Templates} />
          <Route path="/settings" component={UserSettings} />
        </Suspense>
      </Switch>
    )
  }
}

const mapDispatchToProps = {
  getUser: getUserActionCreator,
}

const mapStateToProps = () => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserRoutes)
